export default __webpack_public_path__ + "static/media/a036-2.93f0af39.svg";